import React from 'react';

import './post-row-style.css';

function PostRow({ children }) {
  return <div className="post-row f-row">{children}</div>;
}

export default PostRow;
